import React from "react";
import "./index.css";
import "./bootstrap-grid.css";
import "react-tooltip/dist/react-tooltip.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Contexts/AuthProvider";
import { UserInfoProvider } from "./Contexts/UserInfoProvider";
import { ShoppingCartProvider } from "./Contexts/ShoppingCartProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  // <BrowserRouter basename={baseUrl}>
  //   <App />
  // </BrowserRouter>);

  <React.StrictMode>
    <BrowserRouter basename={baseUrl}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <UserInfoProvider>
          <AuthProvider>
            <ShoppingCartProvider>
              <App />
            </ShoppingCartProvider>
          </AuthProvider>
        </UserInfoProvider>
      </LocalizationProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
